import { DesignProp, LayoutProp } from "../PropCategories";

export const gridType = {
  prop: "style-attribute",
  name: "Grid type",
  nameI18n: "builder_ui.prop_type.styles.grid_type.label",
  category: [DesignProp, LayoutProp],
  type: "select",
  defaultValue: "fixed",
  options: [
    {
      label: "Fixed",
      labelI18n: "builder_ui.prop_type.styles.grid_type.fixed",
      value: "fixed",
    },
    {
      label: "Filled",
      labelI18n: "builder_ui.prop_type.styles.grid_type.filled",
      value: "filled",
    },
  ],
} as const;
